import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";

const schema = z.object({
    Name: z.string().min(1, "Name is required"),
    IsActive: z.boolean().optional().default(true),
});

const newOrganizationResolver = zodResolver(schema);

export default newOrganizationResolver;
